<template>
  <v-dialog
    :title="$t('message.entity.actions.resetSecondFactor')"
    :value="active"
    icon="lock_outline"
    max-width="600px"
    lazy
    scrollable
    @input="close"
  >
    <ds-card class="nx-login-form nx-login-form--configure-second-factor">
      <ds-card-title icon="lock_outline">
        {{ $t('message.entity.actions.resetSecondFactor') }}
      </ds-card-title>

      <template v-if="initializedSuccessfully">
        <nx-auth-second-factor-configuration-form
          v-if="!secondFactorResetSuccessfully"
          @close="close"
          @input="onInput"
        />
        <template v-else>
          <ds-text
            v-text="$t('message.login.secondFactor.reset.success')"
          />
        </template>
      </template>

      <template v-else>
        <ds-text
          v-text="$t('message.login.secondFactor.reset.errorRequestingReset')"
        />
      </template>

      <ds-card-actions v-if="!initializedSuccessfully || secondFactorResetSuccessfully">
        <v-btn
          flat
          @click="close"
        >
          {{ closeButtonText }}
        </v-btn>
      </ds-card-actions>
    </ds-card>
  </v-dialog>
</template>

<script>
import NxAuthSecondFactorConfigurationForm
  from '@/modules/authentication/components/AuthSecondFactorConfigurationForm.vue';

export default {
  name: 'NxEntityResetSecondFactorAction',
  components: {
    NxAuthSecondFactorConfigurationForm,
  },
  data() {
    return {
      active: false,
      loading: false,
      initializedSuccessfully: false,
      secondFactorResetSuccessfully: false,
    };
  },
  computed: {
    closeButtonText() {
      return (!this.initializedSuccessfully || this.secondFactorResetSuccessfully)
        ? this.$t('message.common.close')
        : this.$t('message.common.cancel');
    },
  },
  async mounted() {
    this.$emit('loading', true);
    await this.requestSecondFactorReset();
    this.$emit('loading', false);
    this.active = true;
  },
  methods: {
    close() {
      this.active = false;
      this.$emit('close');
    },
    async requestSecondFactorReset() {
      try {
        const result = await this.$store.dispatch('authentication/REQUEST_SECOND_FACTOR_RESET');
        this.initializedSuccessfully = result.success;
      } catch (e) {
        this.initializedSuccessfully = false;
      }
    },
    onInput(success) {
      this.secondFactorResetSuccessfully = success;
    },
  },
};
</script>
